export default __webpack_public_path__ + "static/media/lt.04cf258e.svg";